import React from 'react';
import type AppDiscoverySettingsType from '@atlassian/jira-spa-apps-project-settings-app-discovery/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyAppDiscoverySettings = lazyForPaint<typeof AppDiscoverySettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-app-discovery-settings", jiraSpaEntry: "async-project-settings-app-discovery-settings" */ '@atlassian/jira-spa-apps-project-settings-app-discovery'
		),
	),
);

const AsyncAppDiscoverySettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyAppDiscoverySettings}
		pageId="project-settings-app-discovery-settings"
		shouldShowSpinner={false}
	/>
);

export default AsyncAppDiscoverySettings;
